import { Icon } from '@ps/isp-web-component-library';
import { ChevronMediumDown } from '@ps/isp-web-component-library/icons/ChevronMediumDown';
import type { EventView, MarketView } from '@ps/isp-web-services-types';
import { Link } from '@ps/web-shared-components';
import React from 'react';

import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

import FormattedDateTime from '../FormattedDateTime/FormattedDateTime';

import styles from './OddsBoostEventLink.scss';

interface Props {
  competitionSlug: string | undefined;
  eventTypeSlug: string;
  market: MarketView;
  event: EventView;
}

export const OddsBoostEventLink: React.FC<Props> = ({
  competitionSlug,
  market,
  event,
  eventTypeSlug
}) => {
  const { eventId, eventSlug, eventName, eventStartTime, eventTypeId } = event;

  const icon = getEventTypeIcon(eventTypeId);

  const content = (
    <span className={styles.linkWrapper}>
      <Icon icon={icon} className={styles.linkIcon} size="x1" />
      <span className={styles.linkTitle}>
        <span className={styles.linkTitleName}>{eventName}</span>
        {market.marketLevels[0] === 'AVB_EVENT' && (
          <FormattedDateTime minimal date={eventStartTime} format="long" />
        )}
      </span>
      <Icon icon={ChevronMediumDown} className={styles.linkIcon} size="x1" />
    </span>
  );

  return competitionSlug ? (
    <Link
      className={styles.link}
      alias={market.marketLevels[0] === 'AVB_EVENT' ? 'sportsEvent' : 'sportsCompetitionOutrights'}
      values={{
        competitionId: market.competitionId,
        competitionSlug,
        eventId,
        eventSlug,
        eventTypeId,
        eventTypeSlug
      }}
    >
      {content}
    </Link>
  ) : (
    content
  );
};
